/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Kontakt.
 */
export interface TourRequestContact { 
    id?: number | null;
    firstname?: string | null;
    lastname?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: string | null;
    birthDate?: string | null;
    marketingAccept?: boolean | null;
}

